import styles from "./styles.module.scss";

export const ReviewItem = ({ name, value, color, backgroundColor }) => {
  return (
    <div
      className={styles.reviewItem}
      style={{
        borderColor: color,
        backgroundColor: backgroundColor,
      }}
    >
      <h3>{name}</h3>
      <span style={{ color: color }}>{value}</span>
    </div>
  );
};
